import { DataTable } from "@/src/components/ui/data-table";
import { useEffect, useMemo, useState } from "react";
import { bookingsColumns } from "./bookingsColumns";
import { usePageChange, usePageSize, useSorting } from "./state";
import { Booking } from "./model";
import { fetch } from "@/src/lib/fetch";
import qs from "qs";
import { useBookingsStore } from "../../stores/bookingsStore";
import { useEmit } from "../../lib/actions";
import { useNavigate } from "react-router-dom";

type SearchPagination = {
  total: number;
  pagination: {
    page: number;
    pageSize: number;
  };
};

type BookingsData = {
  data: Booking[];
} & SearchPagination;

export function BookingsTable() {
  const [loading, setLoading] = useState(false);
  const [bookingId, setBookingId] = useState<Booking["id"] | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [bookings, setBookings] = useState<BookingsData>({
    data: [],
    total: 1,
    pagination: {
      page: 1,
      pageSize: 10,
    },
  });
  const navigate = useNavigate();
  const pageSize = usePageSize();
  const page = usePageChange();
  const sort = useSorting();
  const { filters } = useBookingsStore();
  const emit = useEmit<number>("bkg:page");

  const preparedFilters = useMemo(() => {
    return prepareFilters(filters);
  }, [filters]);

  const query = qs.stringify(preparedFilters, { indices: false });

  const fetchBookings = (page: number) =>
    fetch<{ data: Booking[] } & SearchPagination>(
      `/api/bookings?page=${page}&pageSize=${pageSize}${query ? "&" + query : query}&sort=${sort}`,
    );

  useEffect(() => {
    setLoading(true);
    fetchBookings(page).then((data) => {
      setBookings(data);
      setLoading(false);
    });
  }, [page, pageSize, query, sort]);

  console.log("bookings.data", bookings.data)
  return (
    <div className="rounded-md bg-white border overflow-hidden">
      <DataTable
        columns={bookingsColumns}
        data={bookings.data}
        onRowClick={(r) => navigate(`/bookings/${r.id}?tab=overview`)}
        isLoading={loading}
        pagination={{
          pagination: {
            page: +bookings.pagination.page,
            pageSize: +bookings.pagination.pageSize,
          },
          total: bookings.total,
        }}
        onPageClick={(page) => {
          emit(page);
        }}
      />
    </div>
  );
}

function prepareFilters(filters: any) {
  const preparedFilters = { ...filters };
  if (preparedFilters.customer) {
    preparedFilters.customerEmail = preparedFilters.customer.email;
    delete preparedFilters.customer;
  }
  if (preparedFilters.broker) {
    preparedFilters.broker = preparedFilters.broker.id;
  }

  return preparedFilters;
}
